import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';

@Injectable({providedIn: 'root'})
export class JhiResolvePagingParams {
  resolve(route: ActivatedRouteSnapshot): any {
    const page = route.queryParamMap.get('page') || '1';
    const size = route.queryParamMap.get('size') || '20';
    const sort = route.queryParamMap.get('sort') || 'id,asc';
    const parts = sort.split(',');
    return {
      page: +page,
      size: +size,
      predicate: parts[0],
      ascending: parts[1] === 'asc',
    };
  }
}
